export enum StateRequestType {
  IDLE = 'idle',
  ONGOING = 'ongoing',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
}

export enum FilterPeriodType {
  CURRENT_MONTH = 'current_month',
  SPECIFIC_MONTH = 'specific_month',
  CURRENT_YEAR = 'current_year',
  LAST_YEAR = 'last_year',
  LAST_TWELVE_MONTHS = 'last_twelve_months',
  SPECIFIC_PERIOD = 'specific_period',
}

export enum EFlag {
  verde = 'Verde',
  amarela = 'Amarela',
  vermelha_p1 = 'Vermelha P1',
  vermelha_p2 = 'Vermelha P2',
  escassez_hidrica = 'Escassez_hidrica',
}

export enum EFlagColor {
  verde = '#37B34A',
  amarela = '#F9D815',
  vermelha_p1 = '#F42121',
  vermelha_p2 = '#C21B1B',
  escassez_hidrica = '#333333',
}

export enum EFlagIconColor {
  verde = '#fff',
  amarela = '#333',
  vermelha_p1 = '#fff',
  vermelha_p2 = '#fff',
  escassez_hidrica = '#fff',
}
